import React from 'react'
import Error from 'next/error'
import FormazioneCorsiListing from 'react-components/organisms/FormazioneCorsiListing/FormazioneCorsiListing'
import { api } from 'utils'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import MetaSeo from 'components/atomic/MetaSeo'
import { PAGINEDETAIL, FORMAZIONECORSI } from 'utils/endpoint'
import { useTrans } from 'hooks'
const FormazioneCorsi = ({ page, statusCode, corsiFormazione }) => {
  if (!page) return <Error statusCode={statusCode} />

  const t = useTrans()

  const background = page.main_image
    ? { backgroundImage: `url(${page.main_image})` }
    : { backgroundColor: `#e6f1fe` }

  return (
    <>
      <MetaSeo seo={page.seo} />
      <main className="formazione-corsi-page">
        <div className="w-container-fluid u-background-image" style={background}>
          <div className="w-container">
            <Breadcrumbs breadcrumbs={page.breadcrumbs} />
          </div>

          <div className="formazione-corsi-page__header">
            <div className="w-container">
              <h1 className="formazione-corsi-page__header__title">{t('Formazione Viva')}</h1>
              <p className="formazione-corsi-page__header__subtitle">
                {t(
                  'Un’offerta ricca e gratuita per la scuola primaria: pratica didattica, convegni con esperti, laboratori, aggiornamento professionale e molto altro.'
                )}
              </p>
            </div>
          </div>
        </div>

        <div className="formazione-corsi-page__content u-bg-white">
          <div className="w-container">
            <p className="formazione-corsi-page__content__abstract">
              <FormazioneCorsiListing corsiFormazione={corsiFormazione} />
            </p>
          </div>
        </div>
      </main>
    </>
  )
}

export const getStaticProps = async ({ preview, previewData }) => {
  const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'formazione-corsi-all',
    },
    headers,
  })
  const page = await pageResponse.data

  if (!page) {
    return {
      notFound: true,
    }
  }

  let newDefaultContent = null

  const toolbarProps = { toolbarPage: page }

  const corsiFormazioneResponse = await api.get(`${FORMAZIONECORSI}`, {
    params: {
      attributi__valore_attributo_id__exact: null,
    },
    headers,
  })
  const corsiFormazione = await corsiFormazioneResponse.data

  return {
    props: { page, newDefaultContent, ...toolbarProps, corsiFormazione, revalidate: 60 * 10 },
    revalidate: 60 * 10,
  }
}

export default FormazioneCorsi
